// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-quote[data-v-72a5d3dc]{width:80%;padding:96px;padding-top:48px;padding-bottom:48px;background-color:#f5f5f5}@media only screen and (max-width: 959px){.content-quote[data-v-72a5d3dc]{width:100%;padding:36px}.content-quote .align-right[data-v-72a5d3dc]{text-align:left}}", ""]);
// Exports
module.exports = exports;
